import React, { Component } from "react";
import { isMobile } from "../../../constants/css";
import { connect } from "react-redux";
import { getUnreadDealMessages } from "../../../action_managers/deals";
import "./sidebar.scss";
import UserRoles from "../../../constants/roles";
import SidebarItem from "./sidebar_item";
import get from "lodash/get";
import { userHasRole } from "../../../lib/user";
import { updateCurrentRole } from "../../../actions/account";
import { saveUserRole } from "../../../lib/user_store";
import { SignOutActionManager } from "../../../action_managers/account";
import DownChevron from "../../../icons/down-chevron.svg";
import UpChevron from "../../../icons/up-chevron.svg";

class Sidebar extends Component {
  componentDidMount() {
    if (userHasRole(this.props.user, UserRoles.Creator)) {
      this.props.getUnreadDealMessages(this.props.user);
      this.interval = setInterval(
        () => this.props.user && this.props.getUnreadDealMessages(this.props.user),
        30000
      );
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  state = {
    showRolePanel: false,
  };

  updateCurrentRole = role => {
    this.props.updateCurrentRole(role);
    saveUserRole(role);
  };

  getRolesToRender = () => {
    return Object.keys(this.props.user.roles)
      .filter(role => this.props.user.roles[role] && role !== this.props.currentRole)
      .map(role => (
        <div className={"options"} onClick={() => this.updateCurrentRole(role)} key={role}>
          Switch Roles to {role}
        </div>
      ));
  };

  renderSwitcher = () => {
    if (!this.props.user || !this.state.showRolePanel) {
      return null;
    }

    return (
      <div className={"main-sidebar__role-switcher"}>
        {this.getRolesToRender()}
        <div className={"options"} onClick={() => this.props.logOut(this.props.user.authtoken)}>
          Sign out
        </div>
      </div>
    );
  };

  openRoleSwithcer = e => {
    if (this.state.showRolePanel) {
      this.closeRoleSwitcher();
      return;
    }
    e.stopPropagation();
    this.setState({ showRolePanel: true });
    window.addEventListener("click", this.closeRoleSwitcher);
  };

  closeRoleSwitcher = () => {
    this.setState({ showRolePanel: false });
    window.removeEventListener("click", this.closeRoleSwitcher);
  };

  render() {
    const isAdvertiser =
      this.props.currentRole === UserRoles.Advertiser ||
      userHasRole(this.props.user, UserRoles.Admin);
    const isCreator =
      this.props.currentRole === UserRoles.Creator || userHasRole(this.props.user, UserRoles.Admin);
    const isSponsor =
      this.props.currentRole === UserRoles.Sponsor || userHasRole(this.props.user, UserRoles.Admin);
    var mainClasses = "main-sidebar";
    if (this.props.sidebarOpen) {
      mainClasses += " main-sidebar--active";
    }

    if (this.props.hideSidebar) {
      mainClasses += " main-sidebar--hidden";
    }

    const promotionsLabel = this.props.unreadDealMessages
      ? `Cross Promotions (${this.props.unreadDealMessages})`
      : "Cross Promotions";

    return (
      <div className={mainClasses}>
        <div className="main-sidebar__inner">
          <div className="main-sidebar__header">
            <div className="main-sidebar__close" onClick={this.props.toggleSidebar}>
              <span className="glyphicon glyphicon-remove" />
            </div>
            <div
              className="main-sidebar__logo"
              onClick={() => {
                this.props.push("/");
                if (isMobile()) {
                  this.props.toggleSidebar();
                }
              }}
            />
          </div>

          <nav className={"main-sidebar__nav"}>
            <ul className="list-unstyled main-sidebar__components">
              {isSponsor && (
                <SidebarItem
                  label="Sponsoring"
                  route="/sponsor-show-list"
                  toggleSidebar={this.props.toggleSidebar}
                />
              )}
              {isCreator && (
                <SidebarItem
                  label="Podcasts"
                  route="/shows"
                  toggleSidebar={this.props.toggleSidebar}
                />
              )}
              {isAdvertiser && (
                <SidebarItem
                  label="Campaigns"
                  route="/campaigns"
                  toggleSidebar={this.props.toggleSidebar}
                />
              )}
              {isAdvertiser && (
                <SidebarItem
                  label="Browse Podcasts"
                  route="/browse"
                  toggleSidebar={this.props.toggleSidebar}
                />
              )}
              {isCreator && (
                <SidebarItem
                  label="Analytics"
                  route="/stats"
                  toggleSidebar={this.props.toggleSidebar}
                />
              )}
              {isCreator && (
                <SidebarItem
                  label={promotionsLabel}
                  route="/promotions"
                  toggleSidebar={this.props.toggleSidebar}
                />
              )}
              {isCreator && (
                <SidebarItem
                  label="Dynamic Insertion"
                  route="/dynamic-insertion"
                  toggleSidebar={this.props.toggleSidebar}
                />
              )}
              {isCreator && (
                <SidebarItem
                  label="Money"
                  route="/monetization"
                  toggleSidebar={this.props.toggleSidebar}
                />
              )}

              <SidebarItem
                label="Account"
                route="/account"
                toggleSidebar={this.props.toggleSidebar}
              />
              <SidebarItem
                label="Support"
                route="/support"
                toggleSidebar={this.props.toggleSidebar}
              />
            </ul>
          </nav>
          <div className="main-sidebar__footer">
            <hr className="main-sidebar__bar" />
            <div className="main-sidebar__footer-label">LOGGED IN AS:</div>
            {this.renderSwitcher()}
            <p className={"main-sidebar__name"} onClick={this.openRoleSwithcer}>
              {get(this.props, "user.firstName")}{" "}
              <img
                src={this.state.showRolePanel ? DownChevron : UpChevron}
                alt="role-switcher-chevron"
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ deals, user }) => ({
    deals,
    user: user.user,
    currentRole: user.currentRole,
    unreadDealMessages: deals.unread,
  }),
  {
    logOut: token => new SignOutActionManager({ token }).run(),
    updateCurrentRole,
    getUnreadDealMessages,
  }
)(Sidebar);
